import { render, staticRenderFns } from "./ViewProposal.vue?vue&type=template&id=387d528a&scoped=true&"
import script from "./ViewProposal.vue?vue&type=script&lang=js&"
export * from "./ViewProposal.vue?vue&type=script&lang=js&"
import style0 from "./ViewProposal.vue?vue&type=style&index=0&id=387d528a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d528a",
  null
  
)

export default component.exports